import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useDateConfig } from "./DateContext";
import { formatDateTime } from "./formatDateTime";

export function useFormatDate() {
  const config = useDateConfig();
  // Subscribes the caller to language changes: formatDateTime writes Hindi
  // month names and relative times while the UI is in Hindi.
  const { i18n } = useTranslation();
  const language = i18n.language;

  // Stable between renders (a new function each time defeated every memo
  // that lists formatDate as a dependency); a new one only when the date
  // settings or the language change.
  return useCallback(
    (input: string | number | Date | undefined, options?: any) =>
      formatDateTime(input, config, options),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- language is a deliberate re-create trigger
    [config, language],
  );
}
